<template>
    <Layout class="main">
        <div class="sider-menu-con" :mode="expand">
            <sider>
                <logo slot="logo"/>
            </sider>
        </div>
        <main-header />
        <div class="single-page-con" :mode="expand">
            <div class="single-page" style="padding-bottom:32px">
                <keep-alive >
                    <router-view></router-view>
                </keep-alive>
            </div>
        </div>
        <status-bar  :mode="expand"/>
    </Layout>
</template>
<script>
import MainHeader from '@/components/main-header'
import logo from '@/components/logo'
import Sider from '@/components/sider'
import StatusBar from '@/components/status-bar'
import {mapGetters} from 'vuex'
export default {
    components:{MainHeader,Sider,logo,StatusBar},
    computed:{
        ...mapGetters('app/',['expand']),
        ...mapGetters('user/',['token']),
    },
      created(){
        console.log(this.token);
    }
}
</script>